<template>
    <div>
        <el-card>
            <card-header :title="isEdit ? $t('contentsUpdate') : $t('contentsCreate')" />
            <form>
                <div class="el-form-item">
                    <ul>
                        <li 
                            v-for="(value, key, index) in languages" 
                            :key="key"
                            :class="{'is-active' : isActiveTab(index)}"    
                        >
                            <a @click="active = index">{{value}}</a>
                        </li> 
                    </ul>
                </div>

                <div v-for="(value,key, index) in languages"  v-if="isActiveTab(index)" v-bind:key="key">

                    <InputField 
                        :label="$t('contentsTitle')" 
                        :error="errors.title ? errors.title[0] : ''" 
                        v-model="content.title[key]" />

                    <InputField 
                        :label="$t('contentsSubtitle')" 
                        :error="errors.subtitle ? errors.subtitle[0] : ''"
                        v-model="content.subtitle[key]" />
                    
                    <span> {{ $t('contentsText') }} </span>
                    <wysiwyg :class="errors.text ? 'input-error' : 'input-field'" v-model="content.text[key]"></wysiwyg>
                    <small v-if="errors.text" style="padding-bottom: 20px; color: red"> {{ errors.text[0] }} </small>
                </div>
                
            </form>
        </el-card>
        <!-- <br>
        <el-card v-if="isEdit">
            <images-view @deleteImage="deleteImage" :imageSource="image" />
            <br>
            <upload-file label=" " :modal="true" :originalImage="uploadImage" @formData="upload"/>
        </el-card> -->

        <shared-buttons discardPath="Contents" @confirm-event-fired="save" :isEdit="isEdit ? true : false"/>
    </div>
</template>

<script>
    import api from '@/api/api'
    import {mapGetters} from 'vuex'
    import CardHeader from '../LayoutPart/CardHeader'
    import InputField from '../Inputs/InputField'
    import UploadFile from '../UploadFile/UploadFile'
    import model from '@/model/index'
    import ImagesView from '../UploadFile/ImagesView'
    import { success, error, warning } from '../Notification/notification'

    export default {
        props: {
            content: {
                isRequired: true
            },
            isEdit: {
                type: Boolean,
                isRequired: false
            }
        },
        components: {
            CardHeader,
            InputField,
            UploadFile,
            ImagesView
        },
        data () {
            return {
                active: 0,
                image: {},
                errors: {},
                uploadImage: ''
            }
        },
        computed: {
            languages () {
                return model.getLanguages()
            }
        },
        created () {
            // if (this.content.id) {
            //     this.getContentImages(this.content.id)
            // }
        },
        methods: {
            error,
            success,
            isActiveTab(id) {
                return this.active === id
            },
            // async getContentImages (id) {
            //     let image
            //     await api.fetchContentImages(id)
            //     .then ((res) => {
            //         image = res.data.data
            //     })
            //     this.image = image
            // },
            save () {
                let url = 'newContent'
                this.isEdit ? url = 'updateContent' : 'newContent'
                this.$store.dispatch(url, this.content)
                .then((res) => {
                    if (res === 'success') {

                        this.$router.push({name: 'Contents'})
                    } else {
                        this.errors = res
                        if (this.errors['title.en']) {
                            this.errors.title = [this.errors['title.en'][0]]
                        }
                        if (this.errors['subtitle.en']) {
                            this.errors.subtitle = [this.errors['subtitle.en'][0]]
                        }                        
                    }
                })
            },
            // upload(image) {
            //     let response
            //     this.image.image = image;
            //     api.saveContentImages(this.content.id, image, {
            //                     headers: {
            //                         'Authorization': `Bearer ${this.authToken}`,
            //                         'Content-Type': 'multipart/form-data'
            //                     }
            //     })
            //     .then((res) => {
            //         response = res
            //         if (response.status === 201) {
            //             this.success('Content image', 'added.')
            //             this.getContentImages(this.content.id)
            //         }
            //     })
            //     .catch((err) => {
            //         if (err.status === 422) {

            //             const keys = Object.keys(err.data.fields)
            //             for (let key of keys) {
            //                 this.error(err.data.fields[key][0])
            //             }
            //         }
            //     });               
            // },
            // async deleteImage (id) {
            //     let response
            //     await api.deleteContentImages(id)
            //     .then ((res) => {
            //         if (res.status === 204) {
            //             this.success('This image', 'deleted.')
            //             this.getContentImages(this.content.id)
            //         }
            //     })
            //     .catch ((err) => {

            //     })

                
            // },
        }
    }
</script>

<style scoped>
    .input-field {
        margin-top: 10px;
        margin-bottom: 10px;
    }

    .button {
        margin-left: 10px;
    }

    .right {
        float: right;
    }

    .input-error {
        border: 1px solid red;
        border-radius: 5px;
        /* padding: 0.5px; */
    }

    .questionMark {
        text-align: center;
        border-radius: 50% 50% 50% 50%;
        background-color: #469063;
        color: whitesmoke;
        font-family: Arial;
        font-size: 14px;
        padding-left: 3px;
        padding-right: 3px;
    }
    .el-form-item.is-error .el-input__inner {
        border-color: #f56c6c;
    }

    .el-form-item ul {
        padding: 0;
    }
    
    .el-form-item ul li {
        list-style: none;
        display: inline-block;
        padding-right: 20px;
    }

    .el-form-item ul li a {
        font-weight: bold;
        cursor: pointer;
    }

    .el-form-item ul li.is-active {
        color: #409EFF;
    }

</style>



// WEBPACK FOOTER //
// src/components/Contents/ContentForm.vue